/* Chiemseegarn Reviews Widget – Ersatz für Klaviyo Reviews
   Läd Daten von der reviews-feed Edge Function (Supabase chiemseegarn-marketing). */
(function () {
  if (window.__cgReviewsInit) return;  // Blocks laden das Skript mehrfach — nur einmal initialisieren
  window.__cgReviewsInit = true;
  var API = 'https://txkopmkusrmlefhrqkyh.supabase.co/functions/v1/reviews-feed';
  var KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR4a29wbWt1c3JtbGVmaHJxa3loIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM1OTgxNTAsImV4cCI6MjA5OTE3NDE1MH0.FNNp7hj0ycyO-oAKF37R62b3fbXTjAKPVSjORgHObkg';

  function fetchFeed(params) {
    var qs = Object.keys(params).map(function (k) { return k + '=' + encodeURIComponent(params[k]); }).join('&');
    return fetch(API + '?' + qs, { headers: { Authorization: 'Bearer ' + KEY } }).then(function (r) { return r.json(); });
  }
  function postReview(body) {
    return fetch(API, {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + KEY, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  var STAR_PATH = 'M11.1488 2.23197C10.7159 1.22183 9.28382 1.22183 8.85091 2.23197L6.95034 6.66662H2.67243C1.5588 6.66662 1.00109 8.01305 1.78854 8.8005L4.91029 11.9222L3.59487 17.1839C3.32787 18.2519 4.47191 19.1186 5.42772 18.5724L9.99984 15.9597L14.572 18.5724C15.5278 19.1186 16.6718 18.2519 16.4048 17.1839L15.0894 11.9222L18.2111 8.8005C18.9986 8.01304 18.4409 6.66662 17.3272 6.66662H13.0493L11.1488 2.23197Z';

  function starSVG(fill, size) {
    return '<svg viewBox="0 0 20 20" width="' + size + '" height="' + size + '" aria-hidden="true" style="display:inline-block;vertical-align:-2px">' +
      '<path d="' + STAR_PATH + '" fill="' + fill + '"/></svg>';
  }
  function starPartialSVG(frac, size, id) {
    return '<svg viewBox="0 0 20 20" width="' + size + '" height="' + size + '" aria-hidden="true" style="display:inline-block;vertical-align:-2px">' +
      '<defs><linearGradient id="cgstar' + id + '"><stop offset="' + Math.round(frac * 100) + '%" stop-color="var(--cg-star, #F8BE00)"/>' +
      '<stop offset="' + Math.round(frac * 100) + '%" stop-color="#E5E5E5"/></linearGradient></defs>' +
      '<path d="' + STAR_PATH + '" fill="url(#cgstar' + id + ')"/></svg>';
  }
  var uid = 0;
  function stars(value, size) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (value >= i) html += starSVG('var(--cg-star, #F8BE00)', size);
      else if (value > i - 1) html += starPartialSVG(value - (i - 1), size, ++uid);
      else html += starSVG('#E5E5E5', size);
    }
    return '<span class="cg-stars" role="img" aria-label="' + value + ' von 5 Sternen">' + html + '</span>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function relTime(iso) {
    var d = new Date(iso), now = new Date(), sec = (now - d) / 1000;
    var day = 86400;
    if (sec < day) return 'heute';
    if (sec < 2 * day) return 'gestern';
    if (sec < 30 * day) return 'vor ' + Math.floor(sec / day) + ' Tagen';
    if (sec < 60 * day) return 'vor 1 Monat';
    if (sec < 365 * day) return 'vor ' + Math.floor(sec / (30 * day)) + ' Monaten';
    if (sec < 2 * 365 * day) return 'vor 1 Jahr';
    return 'vor ' + Math.floor(sec / (365 * day)) + ' Jahren';
  }
  var VERIFIED = '<span class="cg-verified"><svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>Verifizierte*r Käufer*in</span>';

  /* ---------- Sterne-Badge (PDP, unter Titel) ---------- */
  document.querySelectorAll('[data-cg-review-stars]').forEach(function (el) {
    var pid = el.getAttribute('data-product-id');
    fetchFeed({ product: pid, limit: 0 }).then(function (d) {
      if (!d.aggregate || !d.aggregate.count) { el.style.display = 'none'; return; }
      el.innerHTML =
        '<a href="#cg-reviews" class="cg-badge" aria-label="' + d.aggregate.avg + ' Sterne, ' + d.aggregate.count + ' Bewertungen">' +
        stars(d.aggregate.avg, 20) +
        '<span class="cg-badge__count">' + d.aggregate.count + ' Bewertungen</span></a>';
      el.querySelector('a').addEventListener('click', function (e) {
        var t = document.getElementById('cg-reviews');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }).catch(function () { el.style.display = 'none'; });
  });

  /* ---------- Review-Liste (PDP) ---------- */
  document.querySelectorAll('[data-cg-reviews-list]').forEach(function (root) {
    var pid = root.getAttribute('data-product-id');
    var ptitle = root.getAttribute('data-product-title') || '';
    var state = { offset: 0, limit: 10, sort: 'newest', stars: 0, total: 0 };

    function loadPage(append) {
      var params = { product: pid, limit: state.limit, offset: state.offset, sort: state.sort };
      if (state.stars) params.stars = state.stars;
      return fetchFeed(params).then(function (d) {
        state.total = d.aggregate.count;
        renderHeader(d.aggregate);
        renderItems(d.reviews, append);
        var shown = state.offset + d.reviews.length;
        root.querySelector('.cg-more').style.display = (d.reviews.length === state.limit && (!state.stars ? shown < state.total : true)) ? '' : 'none';
      });
    }

    function renderHeader(agg) {
      var h = root.querySelector('.cg-list__summary');
      if (!agg.count) { h.innerHTML = '<span class="cg-empty">Noch keine Bewertungen vorhanden.</span>'; return; }
      if (h.getAttribute('data-count') === String(agg.count)) return;   // Filter aendert die Gesamtverteilung nicht
      h.setAttribute('data-count', String(agg.count));
      var html = '<span class="cg-avg">' + String(agg.avg).replace('.', ',') + '</span>' +
        '<span>' + stars(agg.avg, 18) + '<span class="cg-count">' + agg.count + ' Bewertungen</span></span>';
      /* Verteilung: nur in der breiten Ansicht sichtbar (CSS), Klick filtert */
      var dist = agg.distribution;
      if (dist) {
        html += '<div class="cg-dist">';
        for (var s = 5; s >= 1; s--) {
          var n = dist[s] || dist[String(s)] || 0;
          var pct = agg.count ? Math.round(n / agg.count * 100) : 0;
          html += '<button type="button" class="cg-dist__row" data-stars="' + s + '"' + (n ? '' : ' disabled') + '>' +
            '<span class="cg-dist__label">' + s + ' ★</span>' +
            '<span class="cg-dist__bar"><span style="width:' + pct + '%"></span></span>' +
            '<span class="cg-dist__n">' + n + '</span></button>';
        }
        html += '</div>';
      }
      h.innerHTML = html;
      h.querySelectorAll('.cg-dist__row').forEach(function (b) {
        b.addEventListener('click', function () {
          var sel = root.querySelector('.cg-filter');
          var v = b.getAttribute('data-stars');
          sel.value = sel.value === v ? '0' : v;
          sel.dispatchEvent(new Event('change'));
        });
      });
    }

    function renderItems(items, append) {
      var list = root.querySelector('.cg-list__items');
      if (!append) list.innerHTML = '';
      if (!items.length && !append) {
        list.innerHTML = '<div class="cg-empty">Keine Bewertungen in dieser Auswahl.</div>';
        return;
      }
      items.forEach(function (r) {
        var div = document.createElement('div');
        div.className = 'cg-review';
        div.innerHTML =
          '<div class="cg-review__head"><div>' + stars(r.rating, 16) +
          '<div class="cg-review__author">' + esc(r.author_name || 'Anonym') + '</div>' +
          (r.verified ? VERIFIED : '') + '</div>' +
          '<span class="cg-review__date">' + relTime(r.submitted_at) + '</span></div>' +
          (r.title ? '<div class="cg-review__title">' + esc(r.title) + '</div>' : '') +
          (r.body ? '<div class="cg-review__text">' + esc(r.body) + '</div>' : '');
        list.appendChild(div);
      });
    }

    root.querySelector('.cg-sort').addEventListener('change', function () {
      state.sort = this.value; state.offset = 0; loadPage(false);
    });
    root.querySelector('.cg-filter').addEventListener('change', function () {
      state.stars = parseInt(this.value) || 0; state.offset = 0; loadPage(false);
      var v = String(state.stars);
      root.querySelectorAll('.cg-dist__row').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-stars') === v); });
    });
    root.querySelector('.cg-more').addEventListener('click', function () {
      state.offset += state.limit; loadPage(true);
    });

    /* Formular */
    var toggle = root.querySelector('.cg-write'), form = root.querySelector('.cg-form');
    toggle.addEventListener('click', function () {
      form.style.display = form.style.display === 'none' ? '' : 'none';
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      postReview({
        product_id: pid, product_title: ptitle,
        rating: fd.get('rating'), name: fd.get('name'), email: fd.get('email'),
        body: fd.get('body'), website: fd.get('website')
      }).then(function (d) {
        form.innerHTML = d.ok
          ? '<div class="cg-thanks">Danke! Deine Bewertung wurde übermittelt und wird nach kurzer Prüfung veröffentlicht. 🧶</div>'
          : '<div class="cg-thanks">Das hat leider nicht geklappt – bitte versuche es später erneut.</div>';
      }).catch(function () { btn.disabled = false; });
    });

    loadPage(false);
  });

  /* ---------- Carousel (Startseite) ---------- */
  document.querySelectorAll('[data-cg-reviews-carousel]').forEach(function (root) {
    fetchFeed({ scope: 'all', sort: 'top', limit: 12, min_chars: 60 }).then(function (d) {
      var track = root.querySelector('.cg-carousel__track');
      if (!d.reviews || !d.reviews.length) { root.style.display = 'none'; return; }
      var head = root.querySelector('.cg-carousel__agg');
      if (head && d.aggregate) {
        head.innerHTML = stars(d.aggregate.avg, 20) +
          '<span class="cg-count">' + String(d.aggregate.avg).replace('.', ',') + ' von 5 · ' + d.aggregate.count + ' Bewertungen</span>';
      }
      d.reviews.forEach(function (r) {
        var card = document.createElement('div');
        card.className = 'cg-card';
        card.innerHTML = stars(r.rating, 16) +
          '<div class="cg-card__text">' + esc(r.body || r.title || '') + '</div>' +
          '<div class="cg-card__meta"><span class="cg-review__author">' + esc(r.author_name || 'Anonym') + '</span>' +
          (r.verified ? VERIFIED : '') + '</div>' +
          (r.product_title ? '<div class="cg-card__product">' + esc(r.product_title) + '</div>' : '');
        track.appendChild(card);
      });
      var prev = root.querySelector('.cg-carousel__prev'), next = root.querySelector('.cg-carousel__next');
      function step() { return track.querySelector('.cg-card').offsetWidth + 16; }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }).catch(function () { root.style.display = 'none'; });
  });
})();
